import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom'
import './index.css';
import App from './components/App.jsx';
import * as serviceWorker from './serviceWorker';
import '../src/config/i18n';
import { Provider } from 'react-redux';
import { store } from './redux/store';

ReactDOM.render(<BrowserRouter>
    <Provider store={store} >
        <App />
    </Provider>
</BrowserRouter>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
